import React, { useRef, useState } from 'react'
import { useParams } from 'react-router-dom'
import TestCaseList from './testCaseSection/TestCaseList'
import TestRunReport from './reportSection/TestRunReport'
import BasicDetails from './basicDetails/BasicDetails'
import html2canvas from 'html2canvas'
import { message } from 'antd'
import {
    apiDownloadReport,
    getAttachmentPreUrl,
    uploadAttachmentToAWS,
} from '../../../redux/testRun/testRun.service'
import ExportReportModal from './exportReport/ExportReportModal'

const TestRunDetails = () => {
    const { id } = useParams()

    const reportRef = useRef(null) // <- forwardRef target
    const [exporting, setExporting] = useState(false)
    const [isOpen, setOpen] = useState(false)

    // capture helper (returns Blob)
    const captureElementToPngBlob = async (el) => {
        const dpr = Math.max(window.devicePixelRatio || 1, 1)
        const canvas = await html2canvas(el, {
            scale: Math.min(2.5, dpr * 2), // crisp but safe
            useCORS: true,
            backgroundColor: '#ffffff',
            scrollX: 0,
            scrollY: -window.scrollY,
            windowWidth: el.scrollWidth,
            windowHeight: el.scrollHeight,
            logging: false,
        })
        return new Promise((resolve, reject) => {
            canvas.toBlob(
                (blob) =>
                    blob ? resolve(blob) : reject(new Error('toBlob failed')),
                'image/png'
            )
        })
    }

    const generateImageUrl = async (file) => {
        const { name = '', type = '' } = file ?? {}
        const formData = {
            data: [
                {
                    filename: name,
                    contentType: type || 'document',
                },
            ],
        }

        const result = await getAttachmentPreUrl(formData)

        const { success = false, data = {} } = result?.data || {}

        if (success) {
            const uploadURL = data?.[0]?.uploadUrl ?? ''
            const publicLink = data?.[0]?.publicLink ?? ''
            const response = await uploadAttachmentToAWS(file, uploadURL)

            if (response?.ok) {
                return publicLink
            }
            return ''
        }

        return ''
    }

    async function captureElementToFile(el, fileName = 'report.png') {
        const dpr = Math.max(window.devicePixelRatio || 1, 1)
        const canvas = await html2canvas(el, {
            scale: Math.min(2.5, dpr * 2),
            useCORS: true,
            backgroundColor: '#ffffff',
            scrollX: 0,
            scrollY: -window.scrollY,
            windowWidth: el.scrollWidth,
            windowHeight: el.scrollHeight,
            logging: false,
        })

        // --- Crop 20px from left and right ---
        // const cropLeft = 200
        // const cropRight = 200
        // const cropWidth = canvas.width - cropLeft - cropRight
        // const cropHeight = canvas.height

        // const croppedCanvas = document.createElement('canvas')
        // croppedCanvas.width = cropWidth
        // croppedCanvas.height = cropHeight
        // const ctx = croppedCanvas.getContext('2d')

        // ctx.drawImage(
        //     canvas,
        //     cropLeft, // start x in source
        //     0, // start y in source
        //     cropWidth,
        //     cropHeight,
        //     0, // dest x
        //     0, // dest y
        //     cropWidth,
        //     cropHeight
        // )

        return new Promise((resolve, reject) => {
            canvas.toBlob((blob) => {
                if (!blob) {
                    reject(new Error('Failed to create image blob'))
                    return
                }
                const file = new File([blob], fileName, { type: 'image/png' })
                resolve(file)
            }, 'image/png')
        })
    }

    const handleExportImage = async (payload) => {
        try {
            setExporting(true)
            const node = reportRef.current?.getNode?.()
            if (!node) {
                message.error('Report not ready yet')
                return
            }

            // Optional: clean up for capture
            const prev = { boxShadow: node.style.boxShadow }
            node.style.boxShadow = 'none'

            // const blob = await captureElementToPngBlob(node)
            const file = await captureElementToFile(node, `report-${id}.png`)
            const imageUrl = await generateImageUrl(file)

            const formData = {
                ...payload,
                reportImage: imageUrl,
            }

            // restore
            node.style.boxShadow = prev.boxShadow

            const downloadReportResp = await apiDownloadReport(formData)

            const { data } = downloadReportResp
            if (data.status !== 200)
                throw new Error(`Download failed (${data.status})`)

            const link = document.createElement('a')
            link.href = URL.createObjectURL(data?.data) // expecting Blob from your API layer
            link.download = payload?.reportName?.replace(/\s+/g, '_')
            link.click()
            URL.revokeObjectURL(link.href)

            setOpen(false)
        } catch (err) {
            message.error(err.message || 'Failed to export image')
        } finally {
            setExporting(false)
        }
    }

    return (
        <div
            className="container"
            style={{
                zIndex: 10,
                minHeight: '100vh',
                padding: '35px',
                borderRadius: '0px',
            }}
        >
            <div style={{ marginBottom: 10 }}>
                <BasicDetails
                    // onExport={handleExportImage}
                    // exporting={exporting}
                    isOpen={isOpen}
                    setOpen={setOpen}
                />
            </div>
            <div style={{ marginBottom: 10 }}>
                <TestRunReport reportId={id} ref={reportRef} />
            </div>
            <div>
                <TestCaseList
                    reportId={id}
                    // setStateTestRun={setStateTestRun}
                    // stateTestRun={stateTestRun}
                />
            </div>
            <ExportReportModal
                isOpen={isOpen}
                setOpen={setOpen}
                onExport={handleExportImage}
                exporting={exporting}
            />
        </div>
    )
}

export default TestRunDetails
